<div
  class="add-elements-dialog"
  [ngClass]="{ 'dark-theme': _isDarkTheme, 'light-theme': _isLightTheme, 'paper-theme': _isPaperTheme }"
  (keydown)="onKeydown($event)"
>
  <div class="dialog-header">
    <h2>Add to canvas</h2>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <!-- Left: Content types sidebar -->
    <div class="types-panel">
      @for (ct of contentTypes; track ct.type) {
        <button class="type-btn" [class.active]="selectedType() === ct.type" (click)="selectType(ct.type)">
          @if (ct.type === 'create') {
            <img class="ai-btn-logo" alt="Lingo AI" [src]="logoSrc" />
          } @else {
            <mat-icon class="type-icon">{{ ct.icon }}</mat-icon>
          }
          <span>{{ ct.label }}</span>
        </button>
      }
    </div>

    <!-- Right: Content items -->
    <div class="items-panel">
      @if (selectedType() === 'create') {
        <!-- Create by Lingo AI: static sub-type rows -->
        <div class="items-list">
          @for (option of createOptions; track option.subType) {
            <button class="item-row" (click)="selectCreateOption(option.subType)">
              <img class="ai-btn-logo" alt="Lingo AI" [src]="logoSrc" />
              <mat-icon class="item-icon">{{ option.icon }}</mat-icon>
              <span class="item-title">{{ option.label }}</span>
            </button>
          }
        </div>
      } @else if (selectedType() === 'attachment') {
        <!-- Attachment: single static row -->
        <div class="items-list">
          <button class="item-row" (click)="selectAttachment()">
            <mat-icon class="item-icon">attachment</mat-icon>
            <span class="item-title">Attachment</span>
          </button>
        </div>
      } @else if (selectedType()) {
        <mat-form-field class="search-field" appearance="outline">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            [placeholder]="'Search ' + (selectedType() || '')"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
          />
        </mat-form-field>

        @if (isLoading()) {
          <div class="loading-state">
            <mat-spinner [diameter]="32"></mat-spinner>
          </div>
        } @else {
          <div class="items-list">
            @for (item of items(); track item.id) {
              <button class="item-row" (click)="selectItem(item)">
                <mat-icon class="item-icon">{{ getItemIcon() }}</mat-icon>
                <span class="item-title">{{ getItemTitle(item) }}</span>
              </button>
            } @empty {
              <div class="empty-state">No items found</div>
            }
          </div>

          <!-- Pagination -->
          @if (hasPrevPage || hasNextPage) {
            <div class="pagination">
              <button mat-icon-button [disabled]="!hasPrevPage" (click)="prevPage()">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <span class="page-info">Page {{ currentPage }}</span>
              <button mat-icon-button [disabled]="!hasNextPage" (click)="nextPage()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        }
      } @else {
        <div class="empty-state select-type-hint">
          <mat-icon>arrow_back</mat-icon>
          <span>Select a content type</span>
        </div>
      }
    </div>
  </div>
</div>
